import React, {useState} from "react";
import {Box, Button, Column, Columns, Control, Field, Input, TextArea, Title} from "@allxsmith/bestax-bulma";
import axios from "axios";
import {AsyncTypeahead} from "react-bootstrap-typeahead";


export default function NewMovementRate({onSave}){
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();


    const [rate, setRate] = useState({
        name: "",
        cost_per_mile: 0,
        vehicle_cost: 0,
        additional_time_cost: 0,
        callout_cost: 0,
        supplier_cost_per_mile: 0,
        supplier_one_off_charge: 0,
        external_cost_per_mile: 0,
        external_one_off_charge: 0,
        hide: false,
        comments: "",
        customer: null
    });


    const onChange = e => {
        let newRate = {...rate, [e.target.name]: e.target.value}
        setRate(newRate);
    };

    const handleContactSelect = e => {
        const toUpdate = {
            target: {
                name: "customer",
                value: e[0]
            }
        };
        onChange(toUpdate);
    }

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };



    return (
        <Box>
            <details>
                <summary><Title>Add Movement Rate</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Name</label>
                        <Input
                            name={"name"}
                            type={"text"}
                            onChange={onChange}
                            value={rate.name}
                        />
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Cost Per Mile</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"cost_per_mile"}
                                value={rate.cost_per_mile}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Vehicle Cost</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"vehicle_cost"}
                                value={rate.vehicle_cost}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Additional Time Cost</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"additional_time_cost"}
                                value={rate.additional_time_cost}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Callout Cost</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"callout_cost"}
                                value={rate.callout_cost}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Internal Cost Per Mile</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"supplier_cost_per_mile"}
                                value={rate.supplier_cost_per_mile}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">One Off Internal Cost</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"supplier_one_off_charge"}
                                value={rate.supplier_one_off_charge}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">External Supplier Cost Per Mile</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"external_cost_per_mile"}
                                value={rate.external_cost_per_mile}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">One Off External Cost</label>
                        <Control className={"has-addons"}>
                            <Input
                                type={"number"}
                                name={"external_one_off_charge"}
                                value={rate.external_one_off_charge}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <label className="label">Customer</label>
                    <AsyncTypeahead
                      useCache={false}
                      id="typeahead"
                      labelKey="display_name"
                      minLength={2}
                      name={"contact"}
                      onSearch={handleSearch}
                      onChange={handleContactSelect}
                      placeholder={"Search Customer"}
                      options={searchData}
                      ref={typeahead => setTypeahead(typeahead)}
                      className="typeahead"
                      isLoading={isLoading}
                      selected={
                        rate.customer && rate.customer.id ? [rate.customer] : []
                      }
                    />
                </Column>
                <Column>
                    <label className="label">Comments</label>
                    <TextArea
                        value={rate.comments}
                        name={"comments"}
                        onChange={onChange}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={() => onSave(rate)}
                        isFullWidth
                    >
                        Create
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}